<template>
  <b-overlay :show="ticketsList === null" rounded="sm">
    <div v-if="ticketsList !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست تیکت ها</h1>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="ticketsList"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <template #cell(userInfo)="data">
            <div class="cursor-pointer d-flex flex-row">
              {{ data.item.userInfo.name }}
              {{ data.item.userInfo.familyName }}
            </div>
          </template>
          <template #cell(unRead)="data">
            <div class="cursor-pointer d-flex flex-row">
              <p v-if="data.item.unRead">دارد</p>
              <p v-else>ندارد</p>
            </div>
          </template>
          <template #cell(view)="data">
            <div class="cursor-pointer d-flex flex-row">
              <router-link
                :to="{
                  name: 'apps-tickets-detail',
                  params: { id: data.item.ticketId },
                }"
                class="cursor-pointer d-flex flex-row"
              >
                <feather-icon icon="EyeIcon" size="20" />
              </router-link>
            </div>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalCount"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
      id="modal-delete"
      centered
      ok-title="حذف"
      cancelTitle="انصراف"
      @ok="deleteCourse(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import TicketsGetAllRequest from "@/libs/Api/Ticket/TicketGetAllRequest";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
  },
  data() {
    return {
      ticketsList: null,
      totalCount: null,
      perPage: 10,
      currentPage: 1,
      myTableColumns: [
        { key: "ticketId", label: "شناسه" },
        { key: "title", label: "عنوان" },
        { key: "userInfo", label: "نام کاربر" },
        { key: "unRead", label: "پاسخ جدید" },
        { key: "view", label: "جزئیات" },
      ],
    };
  },
  created() {
    this.getAllTickets();
  },
  methods: {
    async getAllTickets() {
      let _this = this;
      let ticketsGetAllRequest = new TicketsGetAllRequest(_this);
      ticketsGetAllRequest.setParams({
        pageNumber: _this.currentPage,
        count: _this.perPage,
      });
      await ticketsGetAllRequest.fetch(
        function (content) {
          _this.ticketsList = content.tickets;
          _this.totalCount = content.ticketCount;
          console.log(_this.ticketsList);
        },
        function (content) {
          console.log(content);
        }
      );
    },
  },
};
</script>
